var angular = require('angular');
var _module = angular.module('benoit');

_module.directive('blurOnEnter', [
    function blurOnEnter() {
        return {
            restrict: 'A',
            link: function blurOnEnterLink($scope, $elem, $attrs) {
                $elem.on('keypress', onKeypress);
                $scope.$on('$destroy', function () { $elem.off('keypress', onKeypress); });

                function onKeypress(e) {
                    if(e.which == 13) {
                        $elem.blur();
                    }
                }
            }
        };
    }
]);
